import React from 'react';
import './contentPlane.css'; // Optional: For custom styles

const ContentPlane = ({ title, text }) => {
  return (
    <div className="content-plane">
      <h1 className="content-title">{title}</h1>
      <div className='divider'></div>
      <p className="content-text">{text}</p>
    </div>
  );
};

export default ContentPlane;
